import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { amsTabs } from "./ApsTabsConfig";
import { AMS_TAB_LABEL, getHash, setHash } from "./hashFunctions";

function getCurrentTabIndex(tabs) {
  const hashValue = getHash(AMS_TAB_LABEL);
  const tabIndex = tabs.findIndex((tab) => tab.title === hashValue);

  if (tabIndex !== -1) {
    return tabIndex;
  } else {
    setHash(AMS_TAB_LABEL, tabs[0].title);
    return 0;
  }
}

export function AmsTabs() {
  const [_, setRerenderKey] = useState(Math.random());
  const { id: projectId } = useParams();
  const reRender = () => setRerenderKey(Math.random());

  const tabs = amsTabs(reRender, projectId);
  const [currentTab, setCurrentTab] = useState(() => getCurrentTabIndex(tabs));

  function handleChange(_, newValue) {
    setCurrentTab(newValue);
    setHash(AMS_TAB_LABEL, tabs[newValue].title);
  }

  return (
    <Box bgcolor="#e5e8f2" flex={1}>
      <Tabs
        value={currentTab}
        onChange={handleChange}
        sx={{ bgcolor: "white" }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.title}
            sx={{
              maxWidth: 100,
              whiteSpace: "normal",
              textAlign: "center",
            }}
          />
        ))}
      </Tabs>

      <Box>{tabs[currentTab].panel}</Box>
    </Box>
  );
}
